import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-email-dialog-button',
  standalone:true,
  imports:[CommonModule, MatButtonModule, MatIconModule],
  template: `
  <div class="email-button">
    <button mat-icon-button (click)="onClick()">
      <mat-icon [ngClass]="iconCls">mail</mat-icon>
    </button>
  </div>
  `
})
export class EmailDialogButtonComponent {

  iconCls = '';

  _data: any;

  @Input() set data(data: any) {
    if (data) {
      this._data = data;
      this.updateIconColor();
    }
  }

  @Output() action = new EventEmitter();

  updateIconColor(){
    if(this._data.hasOwnProperty('emailState')) {
      if(this._data.emailState) {
        this.iconCls = 'green-icon';
      } else {
        this.iconCls = 'red-icon';
      }
    }
  }

  onClick() {
    this.action.emit(this._data);
  }
}
